import uuid from 'uuid';
import { getRailsMessage } from '~/lib/flashMessages';

const MESSAGE_DISPLAY_TIMEOUT = 3000;

const defaultState = () => ({
  message: null,
  timeout: null,
});

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    addMessage(state, flashMessage) {
      Object.assign(state, { message: flashMessage });
    },
    clearMessage(state) {
      Object.assign(state, { message: null });
    },
    resetState(state) {
      Object.assign(state, defaultState());
    },
    saveTimeout(state, timeout) {
      Object.assign(state, { timeout });
    },
    clearTimeout(state) {
      clearTimeout(state.timeout);
      Object.assign(state, { timeout: null });
    },
  },
  actions: {
    addMessage({ commit, dispatch }, flashMessage) {
      const id = uuid.v4();
      commit('clearTimeout');
      commit('addMessage', {
        ...flashMessage,
        id,
      });
      dispatch('setTimeout');
    },
    setTimeout({ commit }) {
      const timeout = setTimeout(() => commit('clearMessage'), MESSAGE_DISPLAY_TIMEOUT);
      commit('saveTimeout', timeout);
    },
    clearMessage({ commit }) {
      commit('clearMessage');
    },
    resetState({ commit }) {
      commit('resetState');
    },
    checkMessages({ commit, dispatch }) {
      if (getRailsMessage()) {
        dispatch('addMessage', getRailsMessage());
      } else {
        commit('clearMessage');
      }
    },
  },
};
